import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { ISeedDivider } from '../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';

export interface ISeedDividerItemProps {
  seedDivider: ISeedDivider;
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
  title?: string;
}

interface ISeedDividerItemState {
  hover: boolean;
}
class SeedDividerItem extends React.Component<ISeedDividerItemProps, ISeedDividerItemState> {

  constructor(props: any) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  render() {
    if (this.props.connectDragSource == undefined) {
      return (<li>{this.props.seedDivider.category.name}</li>);
    }

    const isDragging = (this.props.isDragging != undefined) ? this.props.isDragging : false;
    const className = `product-list-item ${this.props.isDragging ? "active" : ""}`;
    toggleDragginClass(isDragging);
    return this.props.connectDragSource(
      <li
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onMouseDown={() => this.setState({ hover: false })}
        data-title={this.props.title ? this.props.title : null}
        className={`${className} ${this.state.hover ? 'open' : ''}`}
      >{this.props.seedDivider.category.name}</li>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: props.seedDivider,
      type: placeholderTypes.SeedDivider,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

export default (
  DragSource(props => props.type, boxSource, collectDrag)
)(SeedDividerItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ObjectTab/SeedDividerItem.tsx